// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"SelectApplicationTypePage_cancelButton__jARcV"};